require('./devicesTrustedBlockView.scss');

import React from 'react';
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @commons
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKLink } = require('commonsComponents/OKLink');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @utils
const { FormattedText, formatText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');

// @components
const { CallMeBack } = require('components/callMeBack/callMeBack');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const WizardError = require('components/commons/wizardError/wizardError');

// @constants
const { BLOCK_TRUSTED_DEVICE_SECURITY_CODE, NEW_BLOCK_TRUSTED_DEVICE_SECURITY_CODE } = require('constants/operationTypes');
const {DATE_FORMAT_SLASHED_ES} = require('constants/index');
const manageDevicesPath = 'myprofile/devices';

// @actions
const devicesBlockTrustedActions = require('actions/devicesBlockTrusted');
const { validateAgentProfile } = require('actions/devices');

class DevicesTrustedBlockView extends React.Component {

    componentDidMount() {
        if(__CONTACT_CENTER__) this.props.validateAgentProfile();
    }

    componentWillUnmount() {
        this.props.resetBlockTrustedDevice();
    }

    handleConfirmBtnClick = () => {
        const { immDevicesBlockTrusted, requestBlockTrustedDevice, isAgentProfileAuthorized } = this.props;
        const deviceId = immDevicesBlockTrusted.getIn(['trustedDeviceDetails', 'sid']);
        const deviceName = immDevicesBlockTrusted.getIn(['trustedDeviceDetails', 'alias']);
        requestBlockTrustedDevice(deviceId, deviceName, isAgentProfileAuthorized);
    }

    navigateToDeviceManagementSection = () => {
        this.props.history.push(manageDevicesPath);
    }

    rowContent = (key, value) =>(
        <div className="trusted-device-block-view__summary-wrap print-row">
            <div className="trusted-device-block-view__summary-label print-title">
                <FormattedText value={`manageDevices-${key}`} />
            </div>
            &nbsp;
            <div className="trusted-device-block-view__summary-value print-value">
                {value}
            </div>
        </div>
    )

    buildOTPContent() {
        const { immDevicesBlockTrusted, isAgentProfileAuthorized, immProfile } = this.props;
        const deviceName = immDevicesBlockTrusted.getIn(['trustedDeviceDetails', 'alias']);
        const currentDateTime = DateHelper.todayDate(DATE_FORMAT_SLASHED_ES)
        const address = formatText('manageDevices-trustedDeviceBlockingBranch')
        const name = immProfile.get('fullname')

        const operationParams = {
            optional1: deviceName
        }
        const signaturePattern = (
            <SignaturePattern
                togglePrintableStyle={true}
                operationType={isAgentProfileAuthorized
                    ? NEW_BLOCK_TRUSTED_DEVICE_SECURITY_CODE
                    : BLOCK_TRUSTED_DEVICE_SECURITY_CODE}
                operationParams={operationParams}
            />
        );

        return (
            <OKSectionBox>
                <React.Fragment>
                    <OKBoxTitle
                        value={formatText('manageDevices-trustedDeviceBlockingOTPTitle')}
                        isNotSeparator={false}
                    />
                    <FormattedText
                        value="manageDevices-trustedDeviceBlockingConfirmationDesc"
                        injectedStrings={[deviceName]}
                    />
                </React.Fragment>

                <div className="trusted-device-block-view__printable_wrap" id='printable-wizard'>
                    <OKBoxTitle
                        value={formatText('manageDevices-trustedDeviceBlockingOTPTitle')}
                        isNotSeparator={false}
                    />
                    {this.rowContent('trustedDeviceBlockingAddress', `: ${address}`)}
                    {this.rowContent('trustedDeviceBlockingDateTime', `: ${currentDateTime}`)}
                    {this.rowContent('trustedDeviceBlockingClient', `: ${name}`)}
                    {this.rowContent('trustedDeviceBlockingDeviceModel', `: ${deviceName}`)}
                    <div className='trusted-device-block-view__content-wrap print-paragraph print-content'>
                        <FormattedText value='manageDevices-trustedDeviceBlockingText1' />
                    </div>
                </div>
                
                <div className="trusted-device-block-view__separator" />
                {signaturePattern}
                <div className="trusted-device-block-view__separator" />
                <div className="trusted-device-block-view__cancel-link">
                    <OKLink
                        modifier="inherit-styles"
                        to={manageDevicesPath}
                    >
                        <FormattedText value="common-cancel" />
                    </OKLink>
                </div>

                <div className="pull-right">
                    <SignaturePatternButton
                        id="btnBlockTrustedDevice"
                        loading={false}
                        onClick={this.handleConfirmBtnClick}
                    >
                        <FormattedText value="manageDevices-trustedDeviceBlockingConfirmationButton" />
                    </SignaturePatternButton>
                </div>
            </OKSectionBox>
        );
    }

    buildSuccessContent() {
        const goBackButton = {
            label: formatText('manageDevices-trustedDeviceBlockingSuccessButton'),
            url: manageDevicesPath
        };
        return (
            <WizardSuccess
                successMessage={formatText('manageDevices-trustedDeviceBlockingSuccessTitle')}
                mainButton={goBackButton}
            >
                <div className="trusted-device-block-view__success-desc">
                    <FormattedText value="manageDevices-trustedDeviceBlockingSuccessDescOne" />
                </div>
                <div className="trusted-device-block-view__success-desc">
                    <FormattedText value="manageDevices-trustedDeviceBlockingSuccessDescTwo" />
                </div>
            </WizardSuccess>
        )
    }

    buildErrorContent() {
        return (
            <WizardError
                errorMessage={formatText('manageDevices-trustedDeviceBlockingErrorTitle')}
                onMainButtonClick={() => { }}
            >
                <div className="trusted-device-block-view__error-desc">
                    <div>
                        <FormattedText value="manageDevices-trustedDeviceBlockingErrorDescOne" />
                    </div>
                    <div>
                        <FormattedText value="manageDevices-trustedDeviceBlockingErrorDescTwo" />
                    </div>
                </div>
                <div className="trusted-device-block-view__separator" />
                <div className="trusted-device-block-view__error-button pull-right">
                    <OKButton
                        onClick={() => this.navigateToDeviceManagementSection()}>
                        {formatText('manageDevices-trustedDeviceBlockingErrorButton')}
                    </OKButton>
                </div>
            </WizardError>
        )
    }

    render() {
        const { immDevicesBlockTrusted } = this.props;
        let content;

        if (immDevicesBlockTrusted.get('isFetching')) {
            content = <LoadingSection />;
        } else if (immDevicesBlockTrusted.get('isError')) {
            content = this.buildErrorContent();
        } else if (immDevicesBlockTrusted.get('isSuccess')) {
            content = this.buildSuccessContent();
        } else {
            content = this.buildOTPContent();
        }

        const mappingBreadcrumb = [
            {
                text: formatText("profileKeysLanding-title"),
                url: "/myprofile/keys"
            },
            {
                text: formatText("breadcrumb-recentActivity"),
                url: "/myprofile/devices"
            },
            {
                text: formatText("manageDevices-trustedDeviceBlockingConfirmationHeader")
            }
        ]
        return (
            <div className="trusted-device-block-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={formatText("manageDevices-trustedDeviceBlockingConfirmationHeader")}>
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12 col-md-8">
                                {content}
                            </div>
                            <div className="col-xs-12 col-md-4">
                                <CallMeBack isSmall={true} hasEntrance={false} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

DevicesTrustedBlockView.propTypes = {
    history: PropTypes.object.isRequired,
    immDevicesBlockTrusted: PropTypes.object,
    immProfile: PropTypes.object,
    requestBlockTrustedDevice: PropTypes.func,
    resetBlockTrustedDevice: PropTypes.func,
    isAgentProfileAuthorized: PropTypes.bool,
    requestBlockDevice: PropTypes.func,
    validateAgentProfile: PropTypes.func,
};

module.exports.constructor = DevicesTrustedBlockView;

module.exports.DevicesTrustedBlockView = connect(
    state => ({
        immDevicesBlockTrusted: state.devicesBlockTrusted,
        immProfile: state.profile,
        isAgentProfileAuthorized: state.devices.get('isAgentProfileAuthorized'),
    }), {
    requestBlockTrustedDevice: devicesBlockTrustedActions.requestBlockTrustedDevice,
    resetBlockTrustedDevice: devicesBlockTrustedActions.resetBlockTrustedDevice,
    validateAgentProfile,
}
)(withRouter(DevicesTrustedBlockView));

